import { Outlet, Link, useLocation } from 'react-router-dom'
import { Briefcase, Settings, Users, BarChart2, Home } from 'lucide-react'
import { clsx } from 'clsx'

const navItems = [
  { label: 'Dashboard',  path: '/admin',          icon: BarChart2 },
  { label: 'Jobs',       path: '/admin/jobs',      icon: Briefcase },
  { label: 'Users',      path: '/admin/users',     icon: Users },
  { label: 'Settings',   path: '/admin/settings',  icon: Settings },
]

export default function AdminLayout() {
  const location = useLocation()

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Sidebar */}
      <aside className="w-60 bg-white border-r border-gray-200 flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-gray-100">
          <span className="text-lg font-bold text-primary-600">Admin Panel</span>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon
            const active = location.pathname === item.path
            return (
              <Link
                key={item.path}
                to={item.path}
                className={clsx(
                  'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium no-underline transition-colors',
                  active ? 'bg-primary-50 text-primary-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <Icon size={16} />
                {item.label}
              </Link>
            )
          })}
        </nav>
        <div className="p-4 border-t border-gray-100">
          <Link to="/" className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 no-underline">
            <Home size={14} /> Back to App
          </Link>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-16 bg-white border-b border-gray-200 px-6 flex items-center">
          <h1 className="text-lg font-semibold text-gray-900">Referrals Admin</h1>
        </header>
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
